const mongoose = require("mongoose");
export default function calculateDataSize(data) {
  const getItemSize = (item) => {
    if (item === null || item === undefined) return 0;

    switch (typeof item) {
      case "string":
        return item.length * 2; // UTF-16 uses 2 bytes per character
      case "number":
        return 8; // Numbers in JS are 64-bit floating point
      case "boolean":
        return 4;
      case "object":
        if (item instanceof Date) return 8;
        if (item instanceof mongoose.Types.ObjectId) return 12;

        // For arrays and objects, recursively calculate size
        return Object.keys(item).reduce((total, key) => {
          return total + getItemSize(key) + getItemSize(item[key]);
        }, 0);
      default:
        return 0;
    }
  };

  const totalBytes = getItemSize(data);
  const sizeInKB = (totalBytes / 1024).toFixed(2);
  const sizeInMB = (totalBytes / (1024 * 1024)).toFixed(2);

  return {
    bytes: totalBytes,
    kilobytes: parseFloat(sizeInKB),
    megabytes: parseFloat(sizeInMB),
  };
}
